<script>
import { inertia, page } from '@inertiajs/inertia-svelte';
import { Inertia } from '@inertiajs/inertia';

import { createEventDispatcher, afterUpdate } from 'svelte';
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'sveltestrap';

const dispatch = createEventDispatcher();

let showProfile = false;
let showMobileMenu = false;
let currentPath = '';
let isAdmin = false;

$: isAdmin = $page.props.auth.user && $page.props.auth.user.admin

let links = [
  {
    text: 'Pasākumi',
    url: '/admin/events',
  },
];

afterUpdate(() => {
  currentPath = window.location.pathname;
})

function goto(url) {
  Inertia.visit(url);
}

function logout() {
  document.getElementById('logout-form').submit()
}
</script>

<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand" href="/">Plāns</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        {#each links as link}
          <li class="nav-item">
            <a
              use:inertia
              href="{link.url}"
              class="nav-link"
              class:active={link.url===currentPath}
              aria-current="{link.url===currentPath ? 'page' : null}"
            >{link.text}</a>
          </li>
        {/each}
        {#if isAdmin}
          <Dropdown nav inNavbar>
            <DropdownToggle nav caret>Administrēšana</DropdownToggle>
            <DropdownMenu end>
              <DropdownItem on:click={()=>goto('/admin/users')}>Lietotāji</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        {/if}
      </ul>
      <ul class="navbar-nav mb-2 mb-lg-0">
        <li class="nav-item">
          <a on:click={logout} class="nav-link" href="#">Beigt darbu</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
